import React from 'react';
import PropTypes from 'prop-types';
import eeuu from 'images/country-flags/eeuu.svg';
import {HtmlParse} from 'utils'
import style from './style.scss';

const CountriesFlag = ({ countryFlag, plp }) => {
    if(!countryFlag) return false;

    return (
        <div className="country-flag">
            <div className={"country-flag-content " + (plp ? '' : 'pdp')}>
                <i className="country-icon">{HtmlParse(eeuu)}</i>
                <span className="country-text">{plp ? 'Origen' : 'Estados Unidos'}</span>
            </div>
        </div>
    )
}

CountriesFlag.propTypes = {
    countryFlag: PropTypes.string,
    plp: PropTypes.bool,
}

export default CountriesFlag;